import axios from 'axios';
import ApiURLs from '../config/ApiURLs.js';
import FGpending from '../images/FG-pending.png';
import AHpending from '../images/AH-pending.png';
import FG_pending from '../images/FG-no-disponible.png';
import AH_pending from '../images/AH-no-disponible.png';

export default class GLIFOSService {
	constructor() {
		let headers = {};

		let userLocal = localStorage.getItem('userInfo')
			? JSON.parse(localStorage.getItem('userInfo'))
			: null;

		if (
			userLocal &&
			userLocal.access_token /* && userLocal.session.jwt */
		) {
			headers.Authorization = `Bearer ${userLocal.access_token}`;
		}
		let service = axios.create({
			baseURL: ApiURLs.baseURL,
			headers: headers,
		});

		Object.keys(ApiURLs).forEach((element) => {
			if ('baseURL' !== element) {
				GLIFOSService.prototype[element] = function (
					payload,
					params = () => {},
					callback = () => {}
				) {
					let validPayload = true;
					if (undefined !== ApiURLs[element].requires)
						// Parameters Required
						ApiURLs[element].requires.forEach((elementPayload) => {
							validPayload =
								validPayload &&
								payload.hasOwnProperty(elementPayload);
						});
					if (!validPayload)
						return Promise.reject({
							message: 'Not a valid request',
							error: true,
						});
					//console.log('this.service', this.service);
					return this[ApiURLs[element].method](
						ApiURLs[element].href,
						payload,
						params,
						callback
					);
				};
			}
		});

		this.headers = headers;
		this.service = service;
		this.service.interceptors.response.use(
			this.handleSuccess,
			this.handleError
		);
	}

	checkAuth() {
		console.log('check auth...');
		if (!this.headers.Authorization) {
			console.log('no hay Authorization');
			if (
				localStorage.userInfo &&
				localStorage.access_token /* &&
				localStorage.session.jwt */
			) {
				console.log('seteamos authorization');
				this.headers.Authorization = `Bearer ${localStorage.userInfo.access_token}`;
			}
		}
	}

	handleSuccess(response) {
		return response;
	}

	handleError = (error) => {
		console.log(error);
		switch (error.response.status) {
			case 401:
				localStorage.removeItem('userInfo');
				window.location.href = '/';
				break;
			/*case 404:
        this.redirectTo(document, '/404')
        break;*/
			/* default:
				this.redirectTo(document, '/500');
				break; */
			default:
				break;
		}
		return Promise.reject(error);
	};

	redirectTo = (document, path) => {
		document.location = path;
	};

	get(path, payload = {}, params = {}, callback = () => {}) {
		Object.keys(params).forEach((element) => {
			path = path.replace('{%:' + element + '%}', params[element]);
		});
		return this.service
			.get(path, payload)
			.then((response) => callback(response.status, response.data));
	}

	patch(path, payload, callback, params = {}) {
		Object.keys(params).forEach((element) => {
			path = path.replace('{%:' + element + '%}', params[element]);
		});
		return this.service.request({
			method: 'PATCH',
			url: path,
			responseType: 'json',
			data: payload,
		}); //.then((response) => callback(response.status, response.data));
	}

	post(path, payload, callback, params = {}) {
		Object.keys(params).forEach((element) => {
			path = path.replace('{%:' + element + '%}', params[element]);
		});
		return this.service.request({
			method: 'POST',
			url: path,
			responseType: 'json',
			data: payload,
		});
	}
	__getFileSrc(fid) {
		return ApiURLs.baseURL + 'website/file/' + fid;
	}
	__getDefaultThumbSrc(isadg = 'GT-CIRMA-FG') {
		return isadg === 'GT-CIRMA-FG' ? FGpending : AHpending;
	}
	__getDefaultThumbSrcIcon(isadg = 'GT-CIRMA-FG') {
		return isadg === 'GT-CIRMA-FG' ? FG_pending : AH_pending;
	}
	__getThumbSrc(fid, size = 480, isadg = 'GT-CIRMA-FG') {
		if (!fid) return this.__getDefaultThumbSrc(isadg);
		return (
			ApiURLs.baseURL +
			'website/thumbnail/' +
			fid +
			'?w=' +
			size.toString()
		);
	}
	__getThumbSrcIcon(fid, size = 480, isadg = 'GT-CIRMA-FG') {
		if (!fid) return this.__getDefaultThumbSrcIcon(isadg);
		return (
			ApiURLs.baseURL +
			'website/thumbnail/' +
			fid +
			'?w=' +
			size.toString()
		);
	}
}
